module.exports = `${require.publicPath}icon16.33e1f24b.png`;